import { useMemo } from "react";
import classNames from "classnames";
import { emailRegex, getSameEmailRegex } from "../../utils/regex";
import { DEFAULT_QUESTIONS, QUESTIONS, getQuestionLabel } from "../../utils/event";
import Question from "../question";

const EventSurvey = ({
  stage,
  errors,
  register,
  touchedFields,
  dirtyFields,
  control,
  trigger,
  labels,
  formWatch,
  appLang,
  visible,
}) => {
  const eventQuestions = useMemo(
    () => [
      ...DEFAULT_QUESTIONS,
      ...(stage?.guestAllowed ? [QUESTIONS?.find((question) => question.id === "guest_name")] : []),
      ...(stage?.transferAllowed
        ? [QUESTIONS?.find((question) => question.id === "transfer")]
        : []),
    ],
    [stage]
  );

  // const customOnFocus = (elem) => {
  //   const target = elem?.currentTarget;
  //   if (target) {
  //     target.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  //   }
  // };

  return (
    <div className={classNames("event__questions", !visible && "hidden")}>
      {eventQuestions?.map((question) => (
        <Question
          question={{
            ...question,
            label: getQuestionLabel(question.id, labels),
            answers: question?.answers?.map((ans) => ({
              ...ans,
              label: getQuestionLabel(ans.id, labels),
            })),
          }}
          key={question.id}
          register={register}
          error={errors[`${question.id}`]}
          touched={touchedFields[`${question.id}`]}
          isDirty={dirtyFields[`${question.id}`]}
          control={control}
          trigger={trigger}
          labels={labels}
          pattern={
            question.id === "email"
              ? emailRegex
              : question.id === "email_validation"
              ? getSameEmailRegex(formWatch["email_validation"])
              : null
          }
          customPatternErrorMsg={
            question.id === "email"
              ? labels?.WELFARE_NOT_VALID_EMAIL || "The inserted email is not valid"
              : question.id === "email_validation"
              ? labels?.WELFARE_NOT_CORRESPONDING_EMAIL || "The inserted email does not correspond"
              : null
          }
          locale={appLang?.value}
          trim={["email", "email_validation"].includes(question.id)}
          customPh={labels?.[`EVENT_SURVEY_PH_${question.id.toUpperCase()}`]}
          comment={
            question.id === "guest_name" &&
            formWatch?.["guest_name"] &&
            //!reservation?.guestFullName &&
            stage?.availableSeats === 1 && {
              message:
                labels?.EVENT_ALERT_GUEST ||
                "Please note that booking for two people you will be placed on the waiting list",
              className: "form__error-msg",
            }
          }
          // onFocus={question.id === "email" ? customOnFocus : () => null}
        />
      ))}
      <div
        className="event__entrance-info"
        dangerouslySetInnerHTML={{
          __html:
            labels?.EVENT_ENTRANCE_INFO ||
            "<p>Entrance will be permitted only to registered people.</p>",
        }}
      />
    </div>
  );
};

export default EventSurvey;
